<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('cart');

export default {
  name: "CartProgress",

  props: {
    currentStep: {type: Number, default: 0},
  },

  data() {
    return {}
  },

  computed: {
    ...mapState({
      cart: state => state.cart,
      user: state => state.user
    }),

    steps() {
      return [
        {name: 'Create account', href: '#', showAddress: false},
        {name: 'Billing Address', href: '#', showAddress: true, addressType: 'billing'},
        ...this.cart?.hasShipping ? [{
          name: 'Shipping Address',
          href: '#',
          showAddress: true,
          addressType: 'shipping'
        }] : [],
        {name: 'Payment', href: '#', showAddress: false},
        {name: 'Order Confirmation', href: '#', showAddress: false},
      ]
    },
  },

}
</script>

<template>
  <div class="">
    <nav class="relative flex w-full xl:w-auto xl:justify-center" aria-label="Progress">
      <div class="xl:hidden absolute top-1/2 px-2 w-full h-0.5 bg-hurst-dark-orange" aria-hidden="true"/>
      <ol role="list" class="relative space-x-10 xl:space-x-0 xl:space-y-3.5 flex justify-between w-full xl:block">
        <li v-for="(step, stepIdx) in steps" :key="step.name" :class="['relative']">
          <div v-if="stepIdx !== steps.length - 1"
               class="hidden xl:block absolute xl:left-3.5 xl:top-4 xl:-ml-px xl:mt-0.5 h-0.5 w-full xl:h-full xl:w-0.5 bg-hurst-dark-orange"
               aria-hidden="true"/>
          <a v-if=" stepIdx <= currentStep" :href="`#${stepIdx}`"
             @click.prevent="stepIdx===0 ? () => {} : $emit('change-step', stepIdx)" class="flex items-center"
             aria-current="step">
            <span
                class="relative flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-white bg-hurst-dark-orange"
                aria-hidden="true">
              <template v-if="currentStep > stepIdx">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="size-5">
                         <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
                    </svg>
                </template>
                <template v-else>
                  {{ stepIdx + 1 }}
                </template>
            </span>
            <span class="hidden xl:block ml-3 text-sm font-medium text-hurst-light-blue">{{ step.name }}</span>
          </a>
          <a v-else href="#" class="group">
            <div class="flex items-center">
              <span
                  class="relative flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-hurst-light-blue bg-hurst-light-gray border border-hurst-dark-orange"
                  aria-hidden="true">
                  {{ stepIdx + 1 }}
              </span>
              <span class="hidden xl:block ml-3 text-sm font-medium text-hurst-light-blue">{{ step.name }}</span>
            </div>
          </a>
          <div v-if="user !== null && step.showAddress && currentStep > stepIdx"
               class="hidden xl:block text-hurst-blue text-xs ml-10">
            <template v-if="step.addressType === 'billing'">
              <address>
                {{ user.firstName }} {{ user.lastName }}<br/>
                {{ user.addressLine1 }}<br/>
                <template v-if="user.addressLine2 !== ''">{{ user.addressLine2 }}<br/></template>
                {{ user.city }}, {{ user.state }}<br/>
                {{ user.country }}<br/>
                {{ user.zip }}
              </address>
            </template>
            <template v-if="cart !== null && step.addressType === 'shipping' && currentStep > stepIdx">
              <address>
                {{ user.firstName }} {{ user.lastName }}<br/>
                {{ cart.shippingAddress.addressLine1 }}<br/>
                <template v-if="cart.shippingAddress.addressLine2 !== null">{{ cart.shippingAddress.addressLine2 }}<br/>
                </template>
                {{ cart.shippingAddress.city }}, {{ cart.shippingAddress.state }}<br/>
                {{ cart.shippingAddress.country }}<br/>
                {{ cart.shippingAddress.zip }}
              </address>
            </template>
          </div>
        </li>
      </ol>
    </nav>
  </div>
</template>

<style scoped>

</style>